import { FlavorType } from "./user-agent-info.types";
let info;
function parseUserAgent() {
    let flavor = FlavorType.chrome;
    let match = navigator.userAgent.match(/(CrOS \w+|Windows NT|Mac OS X|Linux) ([\d._]+)?/);
    const os = (match || [])[1] || "Unknown";
    const osVersion = (match || [])[2] || "Unknown";
    match = navigator.userAgent.match(/(?:Chrome|Version)\/([\d.]+)/);
    const edgeMatch = navigator.userAgent.match(/(?:Edg|Version)\/([\d.]+)/);
    const firefoxMatch = navigator.userAgent.match(/(?:Firefox)\/([\d.]+)/);
    if (edgeMatch) {
        match = edgeMatch;
        flavor = FlavorType.edge;
    }
    else if (firefoxMatch) {
        match = firefoxMatch;
        flavor = FlavorType.firefox;
    }
    const browserVersion = (match || [])[1] || "Unknown";
    return {
        flavor,
        os,
        osVersion,
        browserVersion,
    };
}
export function getUserAgentInfo() {
    if (!info) {
        info = parseUserAgent();
    }
    return info;
}
